<template>
  <div>
    <div class="media-list">
      <el-row type="flex" align="bottom">
        <el-col :span="22">
          <div class="breadcrumb-bar">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item>学情统计</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="tableList">
      <el-form
        :inline="true"
        :model="formLearn"
        label-width="90px"
        class="searchForm"
      >
        <el-form-item label="学员昵称：">
          <el-input
            v-model="formLearn.name"
            placeholder="输入学员昵称"
          ></el-input>
        </el-form-item>

        <el-form-item label="手机号：">
          <el-input
            v-model="formLearn.phone"
            placeholder="输入多个用空格分隔"
          ></el-input>
        </el-form-item>

        <el-form-item label="班级：">
          <el-select
            v-model="formLearn.className"
            placeholder="请选择"
            clearable
            filterable
            @clear="clearUser"
            @change="changeClass"
          >
            <el-option
              v-for="item in getClassData"
              :key="item.classId"
              :label="item.className"
              :value="item.classId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="阅读记录:">
          <el-select
            v-model="formLearn.weekReadBookCnt"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in getWeekData"
              :key="item.course_id"
              :label="`${item.name}:${item.date}`"
              :value="item.course_id"
            >
              <span> {{ item.name }} </span><span> {{ item.date }} </span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onQuery"
            >搜索</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        ref="multipleTable"
        :header-cell-style="rowClass"
        :data="queryData"
        tooltip-effect="dark"
        @sort-change="FinishRate"
        @selection-change="handleSelectionChange"
        v-loading.body="loading"
        class="table1"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column prop="stuId" label="学员ID" align="center" width="110">
          <template slot-scope="scope">
            <a href="javascript:;" style="color: #1d90e6">{{
              scope.row.stuId
            }}</a>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="学员昵称"
          align="center"
          min-width="120"
        >
          <template slot-scope="scope">
            <a
              href="javascript:;"
              @click="viewStu(scope.row)"
              style="color: #1d90e6"
              >{{ scope.row.name }}</a
            >
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号" align="center" width="100">
        </el-table-column>
        <el-table-column
          prop="className"
          label="班级"
          align="center"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="weekReadBookCnt"
          label="周阅读量"
          sortable
          align="center"
          min-width="120"
        >
          <template slot-scope="scope">
            {{ scope.row.weekReadBookCnt }}/{{ scope.row.weekTotalBookCnt }}本
          </template>
        </el-table-column>
        <el-table-column
          prop="weekReadDuration"
          label="周阅读时长"
          sortable
          align="center"
          min-width="120"
        >
          <template slot-scope="scope">
            {{ scope.row.weekReadDuration | setHis }}
          </template>
        </el-table-column>
        <el-table-column
          prop="totalReadBookCnt"
          label="总阅读量"
          sortable
          align="center"
          min-width="120"
        >
          <template slot-scope="scope">
            {{ scope.row.totalReadBookCnt }}/{{ scope.row.totalBookCnt }}本
          </template> </el-table-column
        ><el-table-column
          prop="totalReadDuration"
          label="总阅读时长"
          sortable
          align="center"
          min-width="120"
        >
          <template slot-scope="scope">
            {{ scope.row.totalReadDuration | setHis }}
          </template> </el-table-column
        ><el-table-column
          prop="totalFinishRateVal"
          sortable
          label="总课程完成率"
          align="center"
          min-width="130"
        >
          <template slot-scope="scope"
            >{{ scope.row.totalFinishRateVal }}%
          </template>
        </el-table-column>
      </el-table>
      <div class="btnFlex" style="margin-top: 30px; float: left">
        <el-button type="primary" @click="exportoper" icon="el-icon-document"
          >导出</el-button
        >
      </div>
      <div class="pagination-box" v-if="pageshow">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryParams.page"
          :page-sizes="[20, 50, 100]"
          :page-size="queryParams.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { ApiMessage } from "@/utils/util";

import { filterMultyNum } from "../commonEdu";
import FileSaver from "file-saver";
import XLSX from "xlsx";

export default {
  name: "learnstatistic",
  data() {
    return {
      // stuId: "",
      formLearn: {
        name: "",
        phone: "",
        className: "",
        weekReadBookCnt: "",
      },
      orderType: "",
      pageTotal: 0,
      queryData: [],
      getClassData: [],
      getWeekData: [],
      getNewerWeek: [],
      newerData: [],
      queryParams: {
        page: 1,
        pageSize: 20,
      },
      multipleSelection: [],
      loading: true,
      pageshow: true,
    };
  },
  filters: {
    setHis(readTime) {
      if (typeof readTime === "number") {
        if (readTime <= 0) {
          return "00小时00分钟00秒";
        } else {
          let hh = parseInt(readTime / 3600); //小时
          let shh = readTime - hh * 3600;
          let ii = parseInt(shh / 60);
          let ss = shh - ii * 60;
          return (
            (hh < 10 ? "0" + hh : hh) +
            "小时" +
            (ii < 10 ? "0" + ii : ii) +
            "分钟" +
            (ss < 10 ? "0" + ss : ss) +
            "秒"
          );
        }
      } else {
        return "00小时00分钟00秒";
      }
    },
  },
  props: {},
  created() {
    this.fetchStuList();
  },
  computed: {},
  mounted() {},
  watch: {},
  methods: {
    setTimeMiao(readTime) {
      if (typeof readTime === "number") {
        if (readTime <= 0) {
          return "00小时00分钟00秒";
        } else {
          let hh = parseInt(readTime / 3600); //小时
          let shh = readTime - hh * 3600;
          let ii = parseInt(shh / 60);
          let ss = shh - ii * 60;
          return (
            (hh < 10 ? "0" + hh : hh) +
            "小时" +
            (ii < 10 ? "0" + ii : ii) +
            "分钟" +
            (ss < 10 ? "0" + ss : ss) +
            "秒"
          );
        }
      } else {
        return "00小时00分钟00秒";
      }
    },
    clearUser() {
      this.getWeekData = [];
    },
    viewStu(stu) {
      this.$router.push({
        name: "detailStu",
        query: {
          id: stu.stuId,
          status: stu.status,
        },
      });
    },
    changeClass(classId) {
      if (!classId) {
        this.formLearn.weekReadBookCnt = "";
        this.newData = [];
        this.queryData = [];
      } else if (classId) {
        this.feachWeekList(classId);
      }
      // }
    },
    rowClass() {
      return "background:#f9f9f9;color:#000000;font-size:14px;height:22px";
    },
    FinishRate(val) {
      if (val.prop == "weekReadBookCnt") {
        this.orderType = "1";
      } else if (val.prop == "weekReadDuration") {
        this.orderType = "2";
      } else if (val.prop == "totalReadBookCnt") {
        this.orderType = "3";
      } else if (val.prop == "totalReadDuration") {
        this.orderType = "4";
      } else if (val.prop == "totalFinishRateVal") {
        this.orderType = "5";
      }
      if (val.order == "descending") {
        this.orderVal = "desc";
      } else if (val.order == "ascending") {
        this.orderVal = "asc";
      }
      this.fetchStuList();
    },
    fetchStuList() {
      this.loading = true;
      let params = {
        appId: this.$API.APPID,
        pageSize: this.queryParams.pageSize,
        page: this.queryParams.page,
      };
      if (this.formLearn.name != "") {
        params.stuName = this.formLearn.name;
      }
      if (this.formLearn.phone != "") {
        params.phone = filterMultyNum(this.formLearn.phone);
      }
      if (this.formLearn.className != "") {
        params.classId = String(this.formLearn.className);
      }
      if (this.formLearn.weekReadBookCnt != "") {
        params.courseId = String(this.formLearn.weekReadBookCnt);
      }
      params.orderVal = this.orderVal;
      params.orderType = this.orderType;
      this.$axios
        .post("/edu/eduAdmin/study/stu_completion_rate_ranking", params)
        .then((res) => {
          if (res != null) {
            if (res.data.rc == 0) {
              this.queryData = res.data.data.list;
              this.pageTotal = res.data.data.pager.total;
              this.feachClassList();
            } else {
              alert(res.data.err);
            }
          }
          this.loading = false;
        });
    },
    async exportoper() {
      console.log("true======================");
      this.loading = true;
      // let stuIds = [];
      // for (let i in this.multipleSelection) {
      //   stuIds.push(`${this.multipleSelection[i].stuId}`);
      // }
      // console.log(stuIds, "stuIds======>>>>>");
      // this.loading = true;
      // let params = {
      //   stuIds: Object(stuIds),
      //   appId: this.$API.APPID,
      //   pageSize: this.queryParams.pageSize,
      //   page: this.queryParams.page,
      // };
      // if (this.formLearn.name != "") {
      //   params.stuName = this.formLearn.name;
      // }
      // if (this.formLearn.phone != "") {
      //   params.phone = filterMultyNum(this.formLearn.phone);
      // }
      // if (this.formLearn.className != "") {
      //   params.classId = String(this.formLearn.className);
      // }
      // if (this.formLearn.weekReadBookCnt != "") {
      //   params.courseId = String(this.formLearn.weekReadBookCnt);
      // }
      // params.orderVal = this.orderVal;
      // params.orderType = this.orderType;
      // console.log(params, ":::params");
      // console.log(this.formLearn, ":::this.formLearn");
      // this.$axios
      //   .post("/edu/eduAdmin/study/stu_completion_rate_ranking", params)
      //   .then((res) => {
      //     if (res != null) {
      //       if (res.data.rc == 0) {
      //         console.log(
      //           this.queryData,
      //           "===>>>>>>>>>>>>>>>this.queryData1111"
      //         );
      //         this.queryData = res.data.data.list;
      //         this.pageTotal = res.data.data.pager.total;
      //         this.loading = false;
      //       } else {
      //         alert(res.data.err);
      //         this.loading = false;
      //       }
      //     }
      //   });
      // let getPage=this.queryParams.page
      // console.log(this.queryParams.page,'this.queryParams.page------');
      // let stuIds = [];
      // for (let i in this.multipleSelection) {
      //   stuIds.push(`${this.multipleSelection[i].stuId}`);
      // }
      // console.log(stuIds,'stuIds======>>>>>');
      // this.loading = true;
      // let params = {
      //   stuIds: Object(stuIds),
      //   appId: this.$API.APPID,
      //   pageSize: this.queryParams.pageSize,
      //   page: this.queryParams.page,
      // };
      // console.log(params,'params========');
      // if (this.formLearn.name != "") {
      //   params.stuName = this.formLearn.name;
      // }
      // if (this.formLearn.phone != "") {
      //   params.phone = filterMultyNum(this.formLearn.phone);
      // }
      // if (this.formLearn.className != "") {
      //   params.classId = String(this.formLearn.className);
      // }
      // if (this.formLearn.weekReadBookCnt != "") {
      //   params.courseId = String(this.formLearn.weekReadBookCnt);
      // }
      // params.orderVal = this.orderVal;
      // params.orderType = this.orderType;
      // console.log(params, ":::params");
      // console.log(this.formLearn, ":::this.formLearn");
      // this.$axios
      //   .post("/edu/eduAdmin/study/stu_completion_rate_ranking", params)
      //   .then((res) => {
      //     if (res != null) {
      //       if (res.data.rc == 0) {
      //         this.queryData = res.data.data.list;
      //         this.pageTotal = res.data.data.pager.total;
      //         this.loading = false;
      //       } else {
      //         alert(res.data.err);
      //         this.loading = false;
      //       }
      //     }
      //   });
      await require.ensure([], () => {
        const { export_json_to_excel } = require("./vendor/Export2Excel");
        const tHeader = [
          "学员ID",
          "学员昵称",
          "手机号",
          "班级",
          "周阅读量",
          "周阅读时长",
          "总阅读量",
          "总阅读时长",
          "总课程完成率",
        ];
        // 上面设置Excel的表格第一行的标题
        const filterVal = [
          "stuId",
          "name",
          "phone",
          "className",
          "weekReadBookCnt",
          "weekReadDuration",
          "totalReadBookCnt",
          "totalReadDuration",
          "totalFinishRateVal",
        ];
        var nowDate = new Date();
        var year = nowDate.getFullYear();
        var month =
          nowDate.getMonth() + 1 < 10
            ? "0" + (nowDate.getMonth() + 1)
            : nowDate.getMonth() + 1;
        var day =
          nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
        var dateStr = year + "" + month + "" + day;
        let datename = "学员学情列表" + dateStr;
        console.log(this.queryData, "===>>>>>>>>>>>>>>>this.queryData");
        const list = JSON.parse(JSON.stringify(this.multipleSelection));
        console.log(this.multipleSelection);
        // let list = [];
        // if (this.multipleSelection.length > 0) {
        //   for (let ms = 0; ms < this.multipleSelection.length; ms++) {

        //     this.mts = JSON.parse(JSON.stringify(this.multipleSelection));
        //     list.push(mts[ms]);
        //     this.mts = this.multipleSelection;
        //     console.log(this.mts, "mts======");
        //     list = JSON.parse(JSON.stringify(this.multipleSelection));
        //   }
        // } else {
        //   list = JSON.parse(JSON.stringify(this.queryData));
        // }

        



        if(this.multipleSelection.length==0){
          alert("请先选择学员后进行导出")
          return
        }

        // if (list.length == 0) {
        //   alert("请先选择数据后进行导出");
        //   return;
        // }
        // const list = this.queryData;
        /////////////////////////////////////////////////////////////////////////////
        // console.log(this.queryData);
        for (let item = 0; item < list.length; item++) {
          // 总课程完成率
          list[item].totalFinishRateVal = list[item].totalFinishRateVal + "%";
          // 周阅读量
          list[item].weekReadBookCnt =
            list[item].weekReadBookCnt +
            "/" +
            list[item].weekTotalBookCnt +
            "本";
          // 总阅读量
          list[item].totalReadBookCnt =
            list[item].totalReadBookCnt + "/" + list[item].totalBookCnt + "本";
          // 总阅读时长
          // console.log(
          //   list[item].totalReadDuration,
          //   item,
          //   list[item].weekReadDuration
          // );
          if (list[item].totalReadDuration) {
            list[item].totalReadDuration = this.setTimeMiao(
              list[item].totalReadDuration
            );
          } else {
            list[item].totalReadDuration = "00小时00分钟00秒";
          }
          // 周阅读时长
          if (list[item].weekReadDuration) {
            list[item].weekReadDuration = this.setTimeMiao(
              list[item].weekReadDuration
            );
          } else {
            list[item].weekReadDuration = "00小时00分钟00秒";
          }
        }

        /////////////////////////////////////////////////////////////////////////////
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, datename);
        // this.fetchStuList()
      });
      console.log("false=================");
      this.loading=false
      // this.fetchStuList()
      // console.log(this.queryData,'----------------------------');
      // let stuIds = [];
      // for (let i in this.multipleSelection) {
      //   stuIds.push(`${this.multipleSelection[i].stuId}`);
      // }
      // if(this.multipleSelection.length==0){
      //   alert('请选择学员')
      //   return
      // }
      // console.log(stuIds,'stuIds======>>>>>');
      //  var xlsxParam = { raw: true }; //转换成excel时，使用原始的格式
      // var wb = XLSX.utils.table_to_book(
      //   document.querySelector(".table1"),
      //   xlsxParam
      // );
      // var wbout = XLSX.write(wb, {
      //   bookType: "xlsx",
      //   bookSST: true,
      //   type: "array",
      // });
      // try {
      //   FileSaver.saveAs(
      //     new Blob([wbout], { type: "application/octet-stream;charset=utf-8" }),
      //     "学员学情统计数据.xlsx"
      //   );
      // } catch (e) {
      //   if (typeof console !== "undefined") console.log(e, wbout);
      // }
      // return wbout;
    },
    formatJson(filterVal, jsonData) {
      console.log(filterVal, jsonData);
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    //班级名称列表请求接口
    feachClassList() {
      let params = {
        appId: this.$API.APPID,
        classId: this.classId,
      };
      this.$axios
        .post("/edu/eduAdmin/class/get_class_or_group_list", params)
        .then((res) => {
          if (res != null) {
            this.getClassData = res.data.data.classList;
          }
          this.loading = false;
        });
    },
    // 获取周数阅读记录列表
    feachWeekList() {
      this.stuId = `${this.$route.query.id}`;
      let params = {
        appId: this.$API.APPID,
        classId: String(this.formLearn.className),
        onlyValid: false,
      };
      this.$axios
        .post("/edu/eduAdmin/course/list_cls_update_date", params)
        .then((res) => {
          if (res != null) {
            this.getWeekData = res.data.data;
            this.newData = [];
            this.getWeekData.forEach((item, index) => {
              this.newData.push({
                currentWeek: `第${item.order + 1}周：`,
                currentDate: item.date,
                courseId: item.course_id,
                index: index,
                curCourse: item.curCourse ? item.curCourse : "",
                order: item.order,
              });
            });
            this.newData.forEach((item, index) => {
              if (item.curCourse && item.curCourse == true) {
                this.formLearn.weekReadBookCnt = item.courseId;
              }
            });
            this.loading = false;
          }
          this.loading = false;
        });
    },
    onQuery() {
      this.queryParams.page = 1;
      this.fetchStuList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      console.log(val, "val--------");
      this.queryParams.pageSize = val;
      this.fetchStuList();
      // this.pageshow=false;
      // this.$nextTick(()=>{
      //   this.pageshow=true
      // })
      // this.fetchStuList({
      //   pageSize :val
      // });
    },
    handleCurrentChange(val) {
      console.log(val, "val=======================");
      // debugger
      this.queryParams.page = val;
      this.$nextTick(() => {
        this.$forceUpdate();
      this.fetchStuList();
      });
    },
  },
};
</script>
<style lang="less">
@import "../fyd-style";
@import "../commonEdu";
</style>



// WEBPACK FOOTER //
// learnStatistic.vue?43a05289